<template>
  <div class="plp-container" :class="mainComputedClasses">
    <div class="container" :class="{'mb-6': marqueeData?.body}">
      <trek-marquee :marquee="marqueeData" :is-simplified="true"></trek-marquee>
    </div>

    <!-- Default cms slots -->
    <slot v-bind="{toggleFiltersState, viewBreakpointLessThan, viewBreakpointMoreThan, areFiltersVisible}"></slot>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState, mapGetters} from 'vuex';
import TrekMarquee from '@/components/TrekMarquee';
import {PdlButton} from '@pedal/pdl-button';
import {PdlIcon} from '@pedal/pdl-icon';
import {PdlDrawer} from '@pedal/pdl-drawer';

export default {
  name: 'PlpContainer',

  components: {
    TrekMarquee,
    // eslint-disable-next-line vue/no-unused-components
    PdlButton,
    // eslint-disable-next-line vue/no-unused-components
    PdlIcon,
    // eslint-disable-next-line vue/no-unused-components
    PdlDrawer,
  },

  props: {
    marqueeData: {
      type: Object,
      default: () => null,
    },
  },

  computed: {
    ...mapGetters('viewSize', ['viewBreakpointLessThan', 'viewBreakpointMoreThan']),
    ...mapState('plp', ['areFiltersVisible']),
    mainComputedClasses() {
      return this.marqueeData?.body ? 'mt-4' : 'mt-0';
    },
  },

  mounted() {
    this.updateLastPlp();
  },
  methods: {
    ...mapMutations('plp', ['setAreFiltersVisible']),
    ...mapActions('storage', ['updateLastPlp']),
    toggleFiltersState() {
      this.setAreFiltersVisible(!this.areFiltersVisible);
    },
  },
};
</script>
